import { styled, Tabs, TabsProps } from "@mui/material"
const MinimalTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
  position: "relative",
  backgroundColor: theme.palette.background.paper,
  borderRadius: "0.5rem",
  minHeight: "unset",
  padding: "4px",
  border: `1px solid ${theme.palette.divider}`,

  "& .MuiTabs-fixed .MuiTabs-flexContainer": {
    height: "100%",
    position: "relative",
    zIndex: 10
  },

  "& .MuiTabs-fixed": {
    overflow: "unset !important",
    overflowX: "unset !important",
    "& .MuiTabs-indicator": {
      width: "100%"
    }
  },

  "& .MuiTabs-fixed .MuiTabs-indicator": {
    height: "100%",
    borderRadius: "0.5rem",
    // backgroundColor: theme.palette.primary.main,
    // boxShadow: theme.shadows[11],
    transition: "all 500ms ease"
  }
}))
export default MinimalTabs
